import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FamilyMemberType } from 'src/app/_enums/family-member-type.enum';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';
import { LeadStatus } from 'src/app/_enums/lead-status.enum';
import { InsuranceMetadatas, Lead } from 'src/app/_types/lead.types';
import { LeadMetadataDetailsV2Component } from 'src/app/shared/components/lead-details/metadata-components-v2/lead-metadata-details-v2/lead-metadata-details-v2.component';

@Component({
  selector: 'app-task-log-metadata-diff',
  standalone: true,
  imports: [CommonModule, LeadMetadataDetailsV2Component],
  templateUrl: './task-log-metadata-diff.component.html',
})
export class TaskLogMetadataDiffComponent {
  @Input() insuranceType?: InsuranceType;

  @Input() leadId?: string;

  @Input() memberId?: string;

  @Input() userId?: string;

  @Input() metadata?: InsuranceMetadatas;

  @Input() baselineMetadata?: InsuranceMetadatas;

  @Input() baselineLeadId?: string;

  @Input() baselineMemberId?: string;

  @Input() baselineUserId?: string;

  protected get currentLead(): Lead | null {
    return this.buildLeadSnapshot(
      this.metadata,
      this.insuranceType,
      this.leadId,
      this.memberId,
      this.userId
    );
  }

  protected get originalLead(): Lead | null {
    return this.buildLeadSnapshot(
      this.baselineMetadata,
      this.insuranceType,
      this.baselineLeadId,
      this.baselineMemberId,
      this.baselineUserId
    );
  }

  private buildLeadSnapshot(
    metadata?: InsuranceMetadatas,
    insuranceType?: InsuranceType,
    leadId?: string,
    memberId?: string,
    userId?: string
  ): Lead | null {
    if (!metadata || !insuranceType || !leadId) {
      return null;
    }

    return {
      leadId,
      insuranceType,
      metadata,
      memberId: memberId ?? '',
      memberName: '',
      memberDetails: {} as Lead['memberDetails'],
      familyMemberDetails: {} as Lead['familyMemberDetails'],
      relation: FamilyMemberType.CHILDREN,
      status: LeadStatus.PENDING,
      createdOn: '',
      createdBy: '',
      isDeleted: false,
      lastUpdatedOn: '',
      agentId: '',
      agentName: '',
      partnerId: '',
      partnerName: '',
      changeReason: [],
      userId,
    };
  }
}
